<template>
  <div>
    <div class="mb-8">
      <div class="flex items-center justify-between gap-8">
        <div class="flex items-center justify-start gap-8">
          <span
            class="cursor-pointer board__inactive"
            :class="{
              board__active: boardType === 'active',
            }"
            id="active"
            @click="boardType = 'active'"
          >
            <h4 class="text-lg w-fit whitespace-no-wrap">Active Boards</h4>
          </span>

          <span
            class="hidden cursor-pointer board__inactive"
            :class="{
              board__active: boardType === 'paused',
            }"
            id="paused"
            @click="boardType = 'paused'"
          >
            <h4 class="text-lg w-fit whitespace-no-wrap">Paused</h4>
          </span>

          <span
            class="cursor-pointer board__inactive"
            :class="{
              board__active: boardType === 'archived',
            }"
            id="archived"
            @click="boardType = 'archived'"
          >
            <h4 class="text-lg w-fit whitespace-no-wrap">Archived</h4>
          </span>
        </div>
        <div
          class="cursor-pointer flex items-center text-white p-2 md:p-4 rounded-lg"
          @click=""
          :style="{
            background: orgData.primaryThemeColor
              ? orgData.primaryThemeColor
              : '#fbb603',
          }"
        >
          <feather-icon icon="PlusIcon" class="mr-2 w-6 h-6" />
          <h4 class="text-lg w-fit whitespace-no-wrap text-white">
            Create new board
          </h4>
        </div>
      </div>
    </div>
    <div v-if="isBoardLoading">
      <vs-row class="rounded-lg grid flex-col lg:grid-cols-2 grid-cols-1 gap-6">
        <vs-row
          v-for="i in 6"
          :key="i"
          class="p-24 rounded-lg my-2 bg-slate-200"
        />
      </vs-row>
    </div>
    <div v-else class="py-4">
      <div
        class="grid flex-col lg:grid-cols-2 grid-cols-1 gap-6"
        v-if="boardsSelected && boardsSelected.length > 0"
      >
        <board-item-card
          v-for="(board, index) in boardsSelected"
          :key="index"
          :boardData="board"
        />
      </div>
      <div v-else>no board found</div>
    </div>
  </div>
</template>

<script>
import BoardItemCard from "./components/BoardItemCard.vue";

export default {
  components: {
    BoardItemCard,
  },
  data() {
    return {
      boardsSelected: [],
      isBoardLoading: true,
      boardType: "",
    };
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    allBoards() {
      if (this.$store.state.boards.allBoards)
        return this.$store.state.boards.allBoards;
      return [];
    },
    allArchivedBoards() {
      if (this.$store.state.boards.allArchivedBoards)
        return this.$store.state.boards.allArchivedBoards;
      return [];
    },
  },
  watch: {
    orgData(newVal) {
      if (newVal) {
        this.isBoardLoading = true;
        this.fetchOrgActiveBoards(this.orgData._id);

        let primaryColor = newVal.primaryThemeColor
          ? newVal.primaryThemeColor
          : "#F2C244";
        // this.$store.commit('UPDATE_PRIMARY_COLOR', primaryColor);
        localStorage.setItem(
          `${this.$route.params.organizationId}_org_color`,
          primaryColor
        );
      }
    },
    boardType(newVal) {
      if (newVal === "active") {
        this.boardsSelected = this.allBoards;
      } else if (newVal === "archived") {
        this.fetchOrgArchivedBoards(this.orgData._id);
        this.boardsSelected = this.allArchivedBoards;
      }
    },
  },
  created() {
    if (this.orgData && this.orgData._id) {
      this.fetchOrgActiveBoards(this.orgData._id);
    }
    this.boardType = "active";
  },
  methods: {
    fetchOrgActiveBoards(orgId) {
      this.$store
        .dispatch("boards/fetchAllBoards", orgId)
        .then((res) => {
          if (res && res.data) {
            this.boardsSelected = res.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isBoardLoading = false;
        });
    },
    fetchOrgArchivedBoards(orgId) {
      this.$store
        .dispatch("boards/fetchAllArchivedBoards", orgId)
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isBoardLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.board {
  &__inactive {
    h4 {
      color: #5e5b5b !important;
      font-weight: 400;
    }
  }

  &__active {
    h4 {
      color: #101828 !important;
      font-weight: 600;
    }
  }
}
</style>
